/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { Text } from "@chakra-ui/react";
import {
  FormInputGroup,
  InputFake,
  LabeFormlStyled
} from "styled/Input.styled";
import { ButtonStyled } from "styled/Buttons.styled";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { __ShowTypeTransp } from "request/configuration/__TypeTranport";
import { AuthContext } from "context/AuthContext";
import { useSelector } from "react-redux";

const FormTypeTransportshow = () => {
  const initialForm = {
    name_typeTransport: "",
    description_typeTransport: "",

    status_typeTransport: ""
  };
  const [form, setForm] = useState(initialForm);
  const { onCloseModal, dataToShow } = useContext(ConfigurationCRUDContext);
  const { authUser } = useContext(AuthContext);
  const token = useSelector((state) => state.auth.dataUser.token);

  useEffect(() => {
    if (dataToShow) {
      const initialpos = async () => {
        try {
          const res = await __ShowTypeTransp(token, dataToShow.id);
          //   console.log(res?.data?.status?.data);
          setForm(res?.data?.status?.data);
        } catch (error) {}
      };
      initialpos();
    } else {
      setForm(initialForm);
      // console.log(dataToShow);
    }
  }, [dataToShow]);

  return (
    <>
      <Text
        fontSize="xl"
        mb={3}
        style={{
          fontWeight: 600,
          borderBottom: "1px solid #bababa80",
          paddingBottom: "1rem"
        }}
      >
        {dataToShow ? form.name_typeTransport : ""}
      </Text>
      <form action="">
        <div className="row">
          <div className="row">
            <div className="col-md-6">
              <FormInputGroup>
                <LabeFormlStyled>Nombre tipo de transporte </LabeFormlStyled>
                <InputFake>{form.name_typeTransport}</InputFake>
              </FormInputGroup>
            </div>
            <div className="col-md-6">
              <FormInputGroup>
                <LabeFormlStyled>
                  Descripción tipo de transporte
                </LabeFormlStyled>
                <InputFake>
                  {form.description_typeTransport === null
                    ? "---"
                    : form.description_typeTransport}
                </InputFake>
              </FormInputGroup>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <FormInputGroup>
              <LabeFormlStyled>Estado</LabeFormlStyled>
              <InputFake>
                {form.status_typeTransport === 1 ? "Activo" : "Inactivo"}
              </InputFake>
            </FormInputGroup>
          </div>
        </div>
        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
          <ButtonStyled type="button" wd="140px" onClick={onCloseModal}>
            Aceptar
          </ButtonStyled>
        </div>
      </form>
    </>
  );
};

export default FormTypeTransportshow;
